module.exports = __webpack_public_path__ + "img/antes_despues_320.9e15ee5b.png";